import {IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {kopierFraAjsTilNg2} from "felles-ng2/modell/ajsNg2ModellBroer";
import {GruppeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {GruppeDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {Debugger} from "debug";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";

const css = require('./administrasjon.scss');
const debug: Debugger = require('debug')('AdministrasjonKontroller');

export class AdministrasjonKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmGruppeAdministrasjon', {
                bindings: {gruppe: "<"},
                controller: AdministrasjonKontroller.forInjisering(),
                template: require('./administrasjon.html')
            });
    }

    static forInjisering() {
        return [
            ng2RegNavn.GruppeDatatjenesteForAjs,
            AdministrasjonKontroller
        ]
    }

    constructor(private gruppeDatatjenesteForAjs: GruppeDatatjenesteForAjs) {
    }

    gruppe: l.GruppeModell; //settes via bindings/$onChanges
    gruppeNg2: GruppeModell;

    private init(gruppe:l.GruppeModell){
        this.gruppeNg2 = kopierFraAjsTilNg2(gruppe);
        this.gruppeDatatjenesteForAjs.tjeneste()
          .then(gruppeDatatjeneste => {
              gruppeDatatjeneste.erstattILokallager(this.gruppeNg2);
          });
    }

    $onChanges(endringer: IOnChangesObject): void {
        debug('$onChanges', endringer);
        dersomChangesInneholder(endringer, 'gruppe', gruppe => this.init(gruppe));
    }

}
